import React from 'react'
import PropTypes from 'prop-types'
import RowButton from 'components/atoms/row-button'
import { STATUS } from 'domains/product-pattern/constants'
import StatusBadge from 'domains/product-pattern/atoms/status-badge'

const actionCellPropTypes = {
  cell: PropTypes.shape({
    row: PropTypes.shape({
      original: PropTypes.object
    })
  })
}

const productMaterialTableColumns = ({
  handleEnableMaterial,
  handleDisableMaterial
}) => {

  const StatusCell = (row) => <StatusBadge status={ row.cell.value } />

  const ActionCell = ({ cell: { row } }) => (
    <div className='d-flex'>
      {
        row.original.status == STATUS.ENABLED ?
          <RowButton
            data={ row.original }
            color='danger'
            onClick={ handleDisableMaterial }
            text='Disable'
          />
          :
          <RowButton
            data={ row.original }
            color='success'
            onClick={ handleEnableMaterial }
            text='Enable'
          />
      }
    </div>
  )

  ActionCell.propTypes = actionCellPropTypes

  return (
    [
      {
        Header   : 'Label',
        accessor : 'label'
      },
      {
        Header         : 'Status',
        accessor       : 'status',
        Cell           : StatusCell,
        disableFilters : true
      },
      {
        Header : 'Actions',
        Cell   : ActionCell
      }
    ]
  )
}

export default productMaterialTableColumns
